import React, { useContext, useEffect, useState } from "react";
import { DatePicker } from 'antd';
import { Form } from 'react-bootstrap';

import { useFormValidation } from '../../contexts/FormContext'
import { Select } from "antd";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

function Error({ id, type, text }) {
  const { errors } = useFormValidation();
  const { t } = useTranslation();

  return (
    <p className="error">
      {errors[id]?.type === "required" &&
        t("errors.required")}
    </p>
  );
}

export function TextField({ className, id, title, validation, placeholder, initial }) {
  const { register, errors } = useFormValidation();

  return (
    <div className={className}>
      <label for={id}>{title}</label>

      <Form.Control
        defaultValue={initial}

        {...register(id, validation)}
        placeholder={placeholder}
        type="text"
      />
      <Error id={id} />

    </div>
  );
}



export function Combobox({ className, id, validation, title, children }) {
  const { register, errors } = useFormValidation();

  return (
    <div className={className}>
      <label for={id}>{title}</label>

      <Form.Select
        className=""
        aria-label="Default select example" {...register(id, validation)}>
        {
          children
        }
      </Form.Select>
      <Error id={id} />
    </div>
  )
}

export function CheckBox({ className, id, validation, title, children }) {
  const { register, errors } = useFormValidation();

  return (
    <div className={className}>
      <label for={id}>{title}</label>
      <input type="checkbox" {...register(id, validation)} />
      <Error id={id} />
    </div>
  )
}
export function TextArea({ id, className, validation, title ,initial}) {
  const { register, errors } = useFormValidation()

  return (
    <div className={className}>
      <label for={id}>{title}</label>
      <textarea rows="10" className="w-100" defaultValue={initial} {...register(id, validation)} ></textarea>
      <Error id={id} />

    </div>

  )
}
export function DateInput({ className, id, validation, title, children }) {
  const { register, setValue, control } = useFormValidation();


  return (
    <div className={className}>
      <label for={id}>{title}</label>
      <input
        {...register(id, validation)}
        defaultValue=""
        className="form-control"
        type="date"
      />
      <Error id={id} />
    </div>
  )
}


export function PaginatedSelect({ ref, returnValue ,className, id, validation, title, children, loadNext }) {

  const { register, control, setValue } = useFormValidation();

  const [loadMore, setloadMore] = useState(true);
  const [nextUrl, setnextUrl] = useState();

  const onScroll = (event) => {


    console.log("ee")
    var target = event.target;
    if (
      loadMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {

      loadNext();
    }
  };


  const getChangeHandlerWithValue = name => value => {
    setValue(name, value);
    if(returnValue) returnValue(value)
  };


  return (
    <div className={className}>
      <label>{title}</label>
      <Select
        onChange={getChangeHandlerWithValue(id)}
        allowClear
        ref={ref}
        onPopupScroll={onScroll}
        className="ant-select-selector"
      >
        {children}
      </Select>
      <Error id={id} />
    </div>
  )
}



